import {
    setDefaults,
} from "react-geocode";
import { toast } from "react-toastify";

const SHARED_FUNCTIONS = require('./shared/shared_functions.json');

// ####### GOOGLE MAPS #######

export const GOOGLE_MAPS_API_KEY = "AIzaSyBoMM4VX8dyMOhtfn_kugMYR2UnAMFaT8M";

setDefaults({
    key: GOOGLE_MAPS_API_KEY,
    language: "et",
    region: "EE",
});



// ####### BACK-END FUNCTIONS #######

function camelCaseToSentenceCase(inputString) {
    inputString = inputString.trim();
    // Add a space before every capital letter and convert to lowercase
    const sentenceCaseString = inputString.replace(/([A-Z])/g, ' $1').toLowerCase();
  
    // Capitalize the first letter
    return sentenceCaseString.charAt(0).toUpperCase() + sentenceCaseString.slice(1);
}

export const DOMAIN = "https://abuss.ee";
export const PORTAL_PREFIX = "/portal";
export const URL_PREFIX = PORTAL_PREFIX + "/api";
export const FN_URL_PREFIX = URL_PREFIX + "/fn";

let FNS = {};

function wait(time) {
    return new Promise(resolve => setTimeout(resolve, time));
}

Object.entries(SHARED_FUNCTIONS).forEach(([key, val]) => {
    FNS[key] = async function(...args) {

        // Function arguments converted into map/object
        let params = null;
        val["args"].forEach((arg, i) => {
            if(params == null) params = {};
            params[arg["name"]] = args[i]
        });

        console.log("outgoing params:", params);

        // Default data for the web request
        let url = FN_URL_PREFIX + "/" + key;
        let body = undefined;
        let headers = {};

        if(val["method"] == "GET") {

            // Override default data for GET request
            // (skip null/undefined args, so optional args are simply left out of the URL)
            if(params) {
                const definedParams = Object.fromEntries(Object.entries(params).filter(([ , value ]) => value != null));
                url += "?" + new URLSearchParams(definedParams);
            }

        } else if(val["method"] == "POST") {

            // Override default data for POST request
            headers = {
                ...headers,
                "Content-Type": "application/json",
            }
            body = JSON.stringify(params);

        }

        // Run web request
        let errorText = null;
        try {
            const data = await fetch(url, {
                method: val["method"],
                credentials: 'include',
                headers: {
                    ...headers,
                },
                body,
            });

            const json = await data.json();

            if("error" in json) {
                errorText = json["error"];
                throw new Error(`[${json["requestID"]}] ${json["error"]}`, { cause: json["error"] });
            }

            // await wait(1000);
            
            return json["content"];
        } catch (e) {
            if(!errorText) errorText = e.message;
            throw new Error("Error funktsioonis \"" + camelCaseToSentenceCase(key) + "\":\n" + errorText, { cause: e });
        }
    };
});

export default FNS;

export async function logIn(username, password) {

    // Run web request
    const data = await fetch(URL_PREFIX + "/login", {
        method: "POST",
        credentials: 'include',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            username,
            password,
        }),
    });

    const json = await data.json();

    if("error" in json) {
        throw new Error(`[${json["requestID"]}] ${json["error"]}`);
    }

    return json["content"]["token"];
}